import { render, staticRenderFns } from "./form-board-create.vue?vue&type=template&id=4de72744&"
import script from "./form-board-create.vue?vue&type=script&lang=js&"
export * from "./form-board-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports